/* eslint react/forbid-prop-types: 0 */
import React from "react";
import { compose, withProps, lifecycle } from "recompose";
import {
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer
} from "react-google-maps";
import JobMapMarker from "./JobMapMarker";

const GOOGLE_API_KEY = "AIzaSyDAQqCVDjer9kXq_opMYPQOtaTdcImZLU0";
const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${
  GOOGLE_API_KEY
}&v=3.exp&libraries=geometry,drawing,places`;
const MapWithADirectionsRenderer = compose(
  withProps({
    googleMapURL,
    loadingElement: <div className="map-full-height" />,
    containerElement: <div className="job-map-container" />,
    mapElement: <div className="map-full-height" />
  }),
  withGoogleMap,
  lifecycle({
    componentDidMount() {
      let jobsWithLocation = this.props.jobs.filter(
        job => job.stop.location && job.stop.location.GPS
      );
      if (!jobsWithLocation.length) {
        return;
      }

      jobsWithLocation = jobsWithLocation.filter(
        j =>
          isFinite(j.stop.location.GPS.Lat) &&
          Math.abs(j.stop.location.GPS.Lat) <= 90
      );

      if (jobsWithLocation.length < 2) {
        return;
      }

      const firstLocation = jobsWithLocation.shift().stop.location;
      const lastLocation = jobsWithLocation.pop().stop.location;
      const otherLocations = jobsWithLocation.map(j => j.stop.location);
      const waypoints = otherLocations.map(l => ({
        location: new window.google.maps.LatLng(l.GPS.Lat, l.GPS.Lng),
        stopover: true
      }));

      const DirectionsService = new window.google.maps.DirectionsService();

      DirectionsService.route(
        {
          origin: new window.google.maps.LatLng(
            firstLocation.GPS.Lat,
            firstLocation.GPS.Lng
          ),
          destination: new window.google.maps.LatLng(
            lastLocation.GPS.Lat,
            lastLocation.GPS.Lng
          ),
          waypoints,
          travelMode: window.google.maps.TravelMode.DRIVING
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            this.setState({ directions: result });
          } else {
            this.setState({ error: `error fetching directions ${result}` });
          }
        }
      );
    }
  })
)(props => {
  const jobsWithLocation = props.jobs.filter(
    job => job.stop.location && job.stop.location.GPS
  );

  if (jobsWithLocation.length) {
    const firstLocation = jobsWithLocation[0].stop.location;

    if (props.error) {
      return <div>{props.error}</div>;
    }

    return (
      <GoogleMap
        defaultZoom={11}
        defaultCenter={
          new window.google.maps.LatLng(
            firstLocation.GPS.Lat,
            firstLocation.GPS.Lng
          )
        }
      >
        {props.directions && (
          <DirectionsRenderer
            directions={props.directions}
            options={{
              suppressMarkers: true
            }}
          />
        )}
        {jobsWithLocation.map(job => (
          <JobMapMarker key={job.externalId} job={job} />
        ))}
      </GoogleMap>
    );
  }

  return <p>Job(s) with no location data</p>;
});

export default MapWithADirectionsRenderer;



// WEBPACK FOOTER //
// ./src/components/jobs/JobMapRoute.js